import * as actionTypes from './actionTypes'
import customerService from 'services/customerService'


export const createCustomerDeliveryAddress = payload => {
  return dispatch => {
    customerService
      .createCustomerDeliveryAddress(payload)
      .then(function (address) {
        dispatch(createdNewCustomerDeliveryAddress(address))
      })
      .catch(function (error) {
        console.log(error)
      })
    }
}

export const createdNewCustomerDeliveryAddress = payload => {
  return {
    type: actionTypes.CREATED_NEW_CUSTOMER_DELIVERY_ADDRESS,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/Customer.js